import React, { useEffect } from "react";
import "./Modal.scss";
import { X } from "lucide-react";

const Modal = ({ show, title, children, onClose, footer, zIndex }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (show) {
      document.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [show, onClose]);

  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("custom-modal-backdrop")) {
      // Backdrop click is disabled to prevent accidental closure
    }
  };

  const backdropStyle = zIndex ? { zIndex } : undefined;
  const modalStyle = zIndex ? { zIndex: Number(zIndex) + 10 } : undefined;

  return (
    <div className="custom-modal-backdrop" onClick={handleBackdropClick} style={backdropStyle}>
      <div className="custom-modal" style={modalStyle}>
        {/* Header */}
        <div className="custom-modal-header">
          <h4 className="custom-modal-title">{title}</h4>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="custom-modal-body">{children}</div>

        {/* Footer */}
        {footer && <div className="custom-modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
